module.exports = __webpack_public_path__ + "static/media/bw.b708b280.svg";